/** Roving tabindex keyboard nav for dashboard bar/project chart groups. */
import { useCallback, useEffect, useState } from 'react';

/**
 * One tab-stop composite for chart bar rows: ArrowLeft/Right move selection,
 * Enter/Space activates. Matches SectionTabs-style "1 stop per group".
 */
export function useRovingBarGroup(itemCount, onActivate) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (itemCount <= 0) {
      setActiveIndex(0);
      return;
    }
    setActiveIndex((i) => Math.min(i, itemCount - 1));
  }, [itemCount]);

  const onKeyDown = useCallback(
    (event) => {
      if (itemCount <= 0) return;

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActiveIndex((i) => Math.min(i + 1, itemCount - 1));
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActiveIndex((i) => Math.max(i - 1, 0));
        return;
      }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate?.(activeIndex);
      }
    },
    [activeIndex, itemCount, onActivate],
  );

  return { activeIndex, setActiveIndex, onKeyDown };
}
